import { FC } from 'react';
import { useMenuContext, useMenuState } from '#baseMenu/hooks';

const ContentWrapper: FC = () => {
  const { Content } = useMenuContext();
  const { isContentLoaded } = useMenuState();

  if (!isContentLoaded) {
    return null;
  }

  return <Content />;
};

export { ContentWrapper };
